import { apiRequest, tokenStore } from '@/lib/apiClient';
import type { AuthResponse, UserDto } from '@/types';

export async function login(username: string, password: string): Promise<AuthResponse> {
  const auth = await apiRequest<AuthResponse>('/api/auth/login', {
    method: 'POST',
    auth: false,
    body: { username, password },
  });
  tokenStore.set(auth);
  return auth;
}

export function fetchMe(): Promise<UserDto> {
  return apiRequest<UserDto>('/api/auth/me');
}

export async function logout(): Promise<void> {
  try {
    await apiRequest('/api/auth/logout', { method: 'POST' });
  } finally {
    tokenStore.clear();
  }
}

export async function changePassword(currentPassword: string, newPassword: string): Promise<void> {
  await apiRequest('/api/auth/change-password', {
    method: 'POST',
    body: { currentPassword, newPassword },
  });
}
